import { Pipe, PipeTransform } from '@angular/core';
import {Site} from '../../graphql-typings/graphql';

@Pipe({
  name: 'siteAddress',
  standalone: false
})
export class SiteAddressPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (this.isSite(value)) {
      const site: Site = value as Site;
      const addressParts: string[] = [];

      if (this.isPrintable(site.address_line_1)) {
        addressParts.push(site.address_line_1);
      }
      if (this.isPrintable(site.address_line_2)) {
        addressParts.push(site.address_line_2);
      }

      if (!(args && args[0] && args[0] !== 'short')) {
        if (this.isPrintable(site.city)) {
          addressParts.push(site.city);
        }
        if (this.isPrintable(site.state)) {
          addressParts.push(site.state);
        }
        if (this.isPrintable(site.postcode)) {
          addressParts.push(site.postcode);
        }
        if (this.isPrintable(site.country)) {
          addressParts.push(site.country);
        }
      }

      return addressParts.join(', ');
    }
    return null;
  }

  isSite(obj): boolean {
    return obj.site_id !== undefined && obj.site_name !== undefined;
  }

  isPrintable(str: string): boolean {
    return str !== undefined && str !== null && str.length > 0;
  }

}
